class AnovaProductRenders extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.track = this.querySelector('[data-anova-render-track]');
    this.slides = Array.from(this.querySelectorAll('[data-anova-render-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-anova-render-dot]'));

    if (!this.track || this.slides.length === 0 || this.slides.length !== this.dots.length) return;

    const { signal } = this.controller;
    this.track.addEventListener('scroll', () => this.scheduleUpdate(), { passive: true, signal });
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.selectSlide(index), { signal });
    });

    this.updateDots(0);
  }

  disconnectedCallback() {
    this.controller?.abort();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  selectSlide(index) {
    const slide = this.slides[index];
    if (!slide || !this.track) return;

    this.track.scrollTo({
      left: slide.offsetLeft - this.track.offsetLeft,
      behavior: 'smooth',
    });
    this.updateDots(index);
  }

  scheduleUpdate() {
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => {
      const target = this.track.scrollLeft;
      const activeIndex = this.slides.reduce((closestIndex, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - target);
        const closestSlide = this.slides[closestIndex];
        const closestDistance = Math.abs(closestSlide.offsetLeft - this.track.offsetLeft - target);
        return distance < closestDistance ? index : closestIndex;
      }, 0);

      this.updateDots(activeIndex);
    });
  }

  updateDots(activeIndex) {
    this.dots.forEach((dot, index) => {
      dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
    });
  }
}

if (!customElements.get('anova-product-renders')) {
  customElements.define('anova-product-renders', AnovaProductRenders);
}
